module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-009"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("CALL FOR REPENTANCE"), _c('br')]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Hosea+6%3A1-11&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("HOSEA 6:1-11")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" The Holy Spirit calls us to pray that Christ will provide us the grace of eternal light (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPRIAN")]), _vm._v("). God judges not for the sake of punishment but for repentance (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOPHYLACT")]), _vm._v(") and healing in Christ (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v("). Jesus’ resurrection was foretold by Hosea, and so will he who was raised revive us to live in his presence (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERUSALEM,")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). We must be baptized with Christ that we may also rise with him on the third day (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). The three days of Jesus’ death represent the passion, descent and resurrection (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS")]), _vm._v("). It was Christ who came down as a shower of rain to be baptized in the Jordan (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IPPOLYTUS")]), _vm._v("). Christ comes to us as both early and late rain, setting the foundation of faith and ensuring a harvest (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). The early rain may also be seen as the law and prophets, whereas the late rain is the gospel (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v("). God offers his mercy to penitents who return to him. It is a clear expression of God’s mercy that he pardons those who repent (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTULLIAN")]), _vm._v("). True repentance frees one from sin and reunites one with God. The angels rejoice when a sinner repents (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENT OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v("). God’s call for mercy was proclaimed by Moses, echoed by Israel and reiterated by Paul (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v("). Both covenants demand the generosity of believers through their words, gifts and righteous "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("deeds as outward evidences of mercy. Moses, the prophets and the apostles repeatedly stress mercy over sacrifice (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). Worship of God displays love and knowledge of God, and both are perfected in Christ (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v("). Love to God and to one’s neighbor enables sacrifice that is acceptable to God (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET")]), _vm._v(").")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-062"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("6:1"), _c('i', [_vm._v(" Call to Repentance")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALL TO")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPRIAN")]), _vm._v(": The Holy Spirit set this forth of old, when he said in the Psalms, “O my king and my God. For to you will I pray; O Lord, in the morning you shall hear my voice. In the morning I will stand before you, and will see you.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN151",
      "id": "ap_NFIN151-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" And again through the prophet the Lord says, “At dawn they will be on watch for me, saying, ‘Let us go and return to the Lord our God.’” Likewise at the setting of the sun and at the end of the day necessarily there must again be prayer. For since Christ is the true sun and the true day, as the sun and the day of the world recede, when we pray and petition that the light come upon us again, we pray for the coming of Christ to provide us with the grace of eternal light. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD’S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER 35.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN152",
      "id": "ap_NFIN152-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNISHMENT")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OAL.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOPHYLACT")]), _vm._v(": For when God snatches away or strikes, no one can heal. Thus in the calamity they remembered God. These may refer to those among the Hebrews who afterward came to believe in Christ. In such a thirst and long captivity they will seek the face, namely, the Son. For he is the mark of the Father’s hypostasis (person). Those who turn to the Son are stripped of the veil which lies on their heart. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN153",
      "id": "ap_NFIN153-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EALER.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": In the beginning he seized Adam’s human nature; for he at once declared it accursed, ascribing it to death and corruption. Thus the wrath has struck, but grace plugged the wound with lint. For Christ has brought the healing. He invited [us] to know the true divine revelation; he confirmed [us] through the Spirit to observe the commandments. He showed us again to be zealous followers by placing us beyond corruption and freeing us from the previous infirmities, namely, sin and passions. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 4.62.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN154",
      "id": "ap_NFIN154-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-063"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("6:2"), _c('i', [_vm._v(" Raised on the Third Day")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESURRECTION.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERUSALEM")]), _vm._v(": A few of the Jews of that time were persuaded, but the world hearkened to the truth. Those who concealed the truth were buried in oblivion, but those who received it were made manifest by the power of the Savior, who rose from the dead and raised the dead himself. In the person of the risen dead the prophet Hosea says plainly, “He will revive us after two days; on the third day he will raise us up, to live in his presence.” C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATECHETICAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTURE 14.4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN155",
      "id": "ap_NFIN155-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESURRECTION OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST.")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": Further on, Hosea foretold the resurrection of Christ on the third day, but in the mysterious way that is proper to prophecy. He says, “He shall heal us after two days, and on the third day we shall rise again.” This is the idea underlying the words of Paul [when he says], “Therefore if you have risen in Christ, seek the things that are above.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN156",
      "id": "ap_NFIN156-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITY OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD 28.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN157",
      "id": "ap_NFIN157-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESURRECTION")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST’S AND")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URS.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": Hear what the prophet says: “God will revive us after two days, and on the third day we shall arise and live in his sight.” The first day is the passion of the Savior for us. The second is the day on which he descended into hell. The third day is the day of resurrection."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN158",
      "id": "ap_NFIN158-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Therefore on the third day “God went before them, by day in a column of cloud, by night in a column of fire.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN159",
      "id": "ap_NFIN159-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" But if according to what we said above, the apostle teaches us rightly that the mysteries of baptism are contained in these words,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN160",
      "id": "ap_NFIN160-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" it is necessary that "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("“those who are baptized in Christ are baptized in his death and are buried with him.” [They must] also arise from the dead with him on the third day,")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN161",
      "id": "ap_NFIN161-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" according to what the apostle says, “He raised up together with him and at the same time made them sit in the heavenly places.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN162",
      "id": "ap_NFIN162-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" When, therefore, you shall have undertaken the mystery of the third day, God will begin to lead you and will himself show you the way of salvation. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XODUS 5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN163",
      "id": "ap_NFIN163-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYS OF")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESURRECTION")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPLAINED.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES")]), _vm._v(": The prince of this world did not want the Lord’s army to recognize the engagement of those three days, as that engagement of which the prophet said, “He will revive us after two days; on the third day he will raise us up.” The first day for us is the passion of the Savior; the second day on which he descended into hell; but the third day is the day of the resurrection. So then on the third day God went before them in a pillar of cloud by day and by night in a pillar of fire, and the people were led through the Red Sea. The three days we can fittingly call the Father, Son and Holy Spirit, for the Father is a day, the Son is one, and the Holy Spirit is one, and these three are one. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON 97.1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN164",
      "id": "ap_NFIN164-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-064"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("6:3"), _c('i', [_vm._v(" How God Comes to Us")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST AS")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIN.")])]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IPPOLYTUS")]), _vm._v(": Nor is this the only thing that proves the dignity of the water. But there is also that which is more honorable than all—the fact that Christ, the maker of all, came down as the rain, and was known as a spring,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN165",
      "id": "ap_NFIN165-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" and diffused himself as a river,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN166",
      "id": "ap_NFIN166-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" and was baptized in the Jordan."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN167",
      "id": "ap_NFIN167-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" For you have just heard how Jesus came to John and was baptized by him in the Jordan. Oh, things strange beyond compare! How should the boundless river that makes glad the city of God"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN168",
      "id": "ap_NFIN168-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" have been dipped in a little water! O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOPHANY 2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN169",
      "id": "ap_NFIN169-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDATION AND")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUIT OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": [God] is called not only at morning or dawn or daybreak; he will come to us as an early and later rain to earth. We accept Christ as an early rain when the foundations of the faith are laid within us, and we shall take him as a late rain when after the crop is ripened we grasp eternal fruits and store them up in the Master’s barn. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 2.6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN170",
      "id": "ap_NFIN170-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW,")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHETS AND")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": For I suppose that he waters in two ways upon us who received faith and have known rightly his manifestation. On the one hand, he reveals knowledge in the spirit of the old and legal, and in addition to these, prophetic teachings. In my view, this is the early rain. On the other hand, he adds to this the late [rain], the interpretation of the gospel’s teachings and the most desirable grace of the apostolic preachings. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 4.62.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN171",
      "id": "ap_NFIN171-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-065"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("6:6-7"), _c('i', [_vm._v(" Love Instead of Sacrifice")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERCIFUL.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTULLIAN")]), _vm._v(": But he would not threaten the impenitent if he failed to pardon the penitent. This would be doubtful only if he had not revealed elsewhere the profusion of his mercy. Has he not said, “He who is fallen shall rise, and he who was turned away shall return”?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN172",
      "id": "ap_NFIN172-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" He it is, most assuredly, who “will have mercy rather than sacrifice.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN173",
      "id": "ap_NFIN173-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" The heavens and the angels who are there rejoice at human repentance. Look at you now, sinner, be of good heart! You see where it is that you are a cause of joy. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENITENCE 8.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN174",
      "id": "ap_NFIN174-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERCY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPLIED TO")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPENTANCE.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENT OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": For to every one who has turned to God in truth and with a whole heart, the doors are open, and the thrice-glad Father receives his truly repentant child. And true repentance is to "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("be no longer bound in the same sins for which he denounced death against himself, but to eradicate them completely from the soul. For on their uprooting God takes up his abode again in you. For it is said there is great and exceeding joy and festivity in the heavens with the Father and the angels when one sinner turns and repents.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN175",
      "id": "ap_NFIN175-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" This is why he cries, “I will have mercy, and not sacrifice.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN176",
      "id": "ap_NFIN176-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICH")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HALL")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVED 39.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN177",
      "id": "ap_NFIN177-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERCY,")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACRIFICE.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v(": God himself has said that he would rather have his commandments obeyed than sacrifice offered to him. God proclaims this, Moses declares it to the people of Israel, Paul preaches it to the nations. Do that which you see is better for the time. “I desire mercy more than sacrifice,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN178",
      "id": "ap_NFIN178-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" it says. Are not those who condemn their sin truer Christians than those who think to defend it? “The just accuses himself in the beginning of his words.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN179",
      "id": "ap_NFIN179-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" The one who accuses himself when he sins is just, not the one who praises himself. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER 51.15.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN180",
      "id": "ap_NFIN180-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERCY TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BSERVED.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v(": Great is the principle of mercy to God. Not only his to us, but also that issuing from us to our fellow servants. In the Old Testament and the New, God lays down innumerable laws pertaining to this matter. He orders us to be benevolent continually in all quarters, through words, money and deeds. And Moses throughout—up and down, here and there—scatters words about these matters in all his legislations. And in the person of God the prophets shout, “I desire mercy, and not sacrifice.” And all the apostles act and speak in harmony with these prophetic words. Therefore let us not neglect the matter."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN181",
      "id": "ap_NFIN181-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" By mercy we greatly benefit ourselves, not the poor only. We receive much more than we provide. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPENTANCE AND")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LMSGIVING 10.5.22.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN182",
      "id": "ap_NFIN182-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORSHIP")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISPLAYS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE AND")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOWLEDGE OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD IN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": Most of all, worship of God displays love. . . . For truly the compassion from beside the Father is Christ, as he takes away the sins, dismisses the charges and justifies by faith, and recovers the lost and makes [them] stronger than death. For what is good and he does not give? Therefore the knowledge of God is better than sacrifice and holocausts, as it is brought to perfection in Christ. For by him and in him we have known the Father, and we have become rich in the justification by faith. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 4.65.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN183",
      "id": "ap_NFIN183-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISPOSITION")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALIDATES")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACRIFICE.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v(": Whereas I [the Lord] have no need of sacrifices, I accept them out of considerateness for the limitations of your way of thinking. These two things, on the contrary, I do require: the right disposition toward me and lovingkindness toward the neighbor, these also being the first obligations I imposed, “You will love the Lord your God with your whole heart, your whole soul, your whole mind and your whole strength; and you will love your neighbor as yourself.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN184",
      "id": "ap_NFIN184-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" But whereas I imposed these obligations, they resembled someone breaking agreements made by him with somebody else. In similar fashion, in fact, they despised my longsuffering and trampled on the laws given them. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 6.6-7.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN185",
      "id": "ap_NFIN185-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6879c866","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap10.vue
// module id = 108
// module chunks = 0